export default __webpack_public_path__ + "static/today_at_apple_2-4c6a7e9511bdbaef73686c0dc767b7c4.jpg";